import React from "react";
import { Helmet } from "react-helmet-async";

const SITE = "https://gumble.games";

// Per-page SEO: title, description, canonical, OG/Twitter. Google renders JS,
// so these client-side tags are picked up on crawl.
export default function SEO({ title, description, path = "/", image, type = "website", noindex = false }) {
  const url = path === "/" ? `${SITE}/` : `${SITE}${path}`;
  const desc = description || "Gumble Studio — math-first casino games, exclusive on Stake. Slots, burst games and weekly crate rewards.";
  const img = image ? (image.startsWith("http") ? image : `${SITE}${image}`) : `${SITE}/logo.png`;
  return (
    <Helmet>
      <title>{title ? `${title} — Gumble Studio` : "Gumble Studio — Slots worth spinning"}</title>
      <meta name="description" content={desc} />
      <link rel="canonical" href={url} />
      {noindex && <meta name="robots" content="noindex, nofollow" />}
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content="Gumble Studio" />
      <meta property="og:title" content={title || "Gumble Studio"} />
      <meta property="og:description" content={desc} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={img} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title || "Gumble Studio"} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={img} />
    </Helmet>
  );
}
